import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
} from '@material-ui/core';

import { Settings, Download, Upload, Cached, ReportProblem } from '@material-ui/icons';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmucnhacungcapAction } from 'src/actions/newdanhmucnhacungcap.action';

import CreateEditDialogNewdanhmucnhacungcap from '../newdanhmucnhacungcap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieunhap from '../newdanhmucphieunhap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieuxuat from '../newdanhmucphieuxuat-detail/CreateEditDialog';

import { NewdanhmucphieunhapAction } from 'src/actions/newdanhmucphieunhap.action';
import { NewdanhmucphieuxuatAction } from 'src/actions/newdanhmucphieuxuat.action';

import moment from 'moment';

const CreateEditDialogDieuChuyenLichSu = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    
    
    // const { selected_laylichsudieuchuyen } = useSelector(state => state.newquanlytonkho)
    const [selected_laylichsudieuchuyen, setLayLichSuDieuChuyen] = useState([]);
    
    const { info, permissions, role } = useSelector(state => state.profile)
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [gia_nhap, setGiaNhap] = useState("0")
    const [gia_thuc_nhap_si_1, setGiaThucNhapSi1] = useState("0")
    const [gia_thuc_nhap_si_2, setGiaThucNhapSi2] = useState("0")
    const [gia_thuc_nhap_si_3, setGiaThucNhapSi3] = useState("0")
    const [giaxuat1, setGiaXuat1] = useState("0")
    const [giaxuat2, setGiaXuat2] = useState("0")
    const [giaxuat3, setGiaXuat3] = useState("0")
    const [chiet_khau_1, setChietKhau1] = useState("0")
    const [chiet_khau_2, setChietKhau2] = useState("0")
    const [chiet_khau_3, setChietKhau3] = useState("0")

    const [nhacungcap_id, setNhacungcapId] = useState("-99");
    const [nhacungcap_name, setNhacungcapName] = useState("");
    const [nhacungcap_select, setNhacungcapSelect] = useState(undefined);
    const [nhacungcapList, setNhacungcapList] = useState([]);

    const additionalOptionNhacungcap = { 'id': '-99', 'ma': 'Nhà cung cấp...', 'ten': '' };

    const [openNewdanhmucnhacungcap, setOpenNewdanhmucnhacungcap] = useState(false);
    const [openNewdanhmucphieunhap, setOpenNewdanhmucphieunhap] = useState(false);
    const [openNewdanhmucphieuxuat, setOpenNewdanhmucphieuxuat] = useState(false);

    const [openDieuChuyen, setOpenDieuChuyen] = useState(false);
    const [openDieuChuyenLichSu, setOpenDieuChuyenLichSu] = useState(false);

    const [dieuChuyenSoKhung, setDieuChuyenSoKhung] = useState("");
    const [dieuChuyenSoMay, setDieuChuyenSoMay] = useState("");

    //==========

    const handleClickOpenNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(true);
    };

    const handleCloseNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(false);
        fetchData();
    };

    //==========

    const onSelectedNewdanhmucphieunhap = (id) => {
        dispatch(NewdanhmucphieunhapAction.findOne(id));
        setOpenNewdanhmucphieunhap(true);
    };

    const handleClickOpenNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(true);
    };

    const handleCloseNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(false);
    };

    //==========

    const onSelectedNewdanhmucphieuxuat = (id) => {
        dispatch(NewdanhmucphieuxuatAction.findOne(id));
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleClickOpenNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleCloseNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(false);
    };

    //==========

    const fetchData = async() => {
        const _dieuchuyenlichsu = await dispatch(NewquanlytonkhoAction.dieuChuyenLichSu({ so_khung: props?.so_khung, so_may: props?.so_may }));
        if (_dieuchuyenlichsu && typeof _dieuchuyenlichsu.data !== 'undefined' && typeof _dieuchuyenlichsu.data.values !== 'undefined') {
            if (typeof _dieuchuyenlichsu.data.nhapKho !== 'undefined') {
                let nhapKhoInfo = _dieuchuyenlichsu.data.nhapKho;
                _dieuchuyenlichsu.data.values.push({
                    createdAt: namThangNgayToCreatedAt(nhapKhoInfo?.newdanhmucphieunhap_ref?.nam_thang_ngay),
                    so_khung: nhapKhoInfo?.so_khung,
                    so_may: nhapKhoInfo?.so_may,
                    khohang_ma: nhapKhoInfo?.newdanhmucphieunhap_ref?.khohang_ma,
                    khohang_ten: nhapKhoInfo?.newdanhmucphieunhap_ref?.khohang_ten,
                    username_dieu_chuyen: nhapKhoInfo?.newdanhmucphieunhap_ref?.username_nguoi_tao,
                    loai_data: "nhap_kho",
                })
            }
            setLayLichSuDieuChuyen(_dieuchuyenlichsu.data.values);
        }
    }

    const namThangNgayToCreatedAt = (nam_thang_ngay) => {
        if (!nam_thang_ngay || nam_thang_ngay.length !== 8) return null;
    
        const nam = Number(nam_thang_ngay.substring(0, 4));
        const thang = Number(nam_thang_ngay.substring(4, 6));
        const ngay = Number(nam_thang_ngay.substring(6, 8));
    
        if (
            isNaN(nam) || isNaN(thang) || isNaN(ngay) ||
            thang < 1 || thang > 12 ||
            ngay < 1 || ngay > 31
        ) {
            return null;
        }
    
        return new Date(nam, thang - 1, ngay, 0, 0, 0).toISOString();
    }

    useEffect(() => {
        if (props.open) {
            fetchData()
            console.log(selected_laylichsudieuchuyen);
        }
    }, [props])

    return (<>
        <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
            <DialogTitle>
            <DialogTitle>Lịch sử điều chuyển của xe có số khung - số máy là: <span style={{color: 'green'}}>{props?.so_khung}</span> - <span style={{color: 'green'}}>{props?.so_may}</span></DialogTitle>
            </DialogTitle>
            <DialogContent style={{ width: '100%', paddingTop: 20 }}>
                {selected_laylichsudieuchuyen && selected_laylichsudieuchuyen.length > 0 && 
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Kho</TableCell>
                                <TableCell>Người điều chuyển</TableCell>
                                <TableCell>Thời điểm điều chuyển</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selected_laylichsudieuchuyen &&
                                selected_laylichsudieuchuyen
                                    .map((item, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={item.so_khung + '_' + index}
                                            >
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{item.khohang_ma} - {item.khohang_ten} {index == 0 ? <>[<span style={{color: 'green'}}>Hiện tại</span>]</> : ''} {item?.loai_data == 'nhap_kho' ? <>[<span style={{color: 'blue'}}>Nhập kho</span>]</> : ''}</TableCell>
                                                <TableCell>{item.username_dieu_chuyen}</TableCell>
                                                <TableCell>
                                                    {moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Đóng</Button>
            </DialogActions>
        </Dialog >
    </>);
}

export default CreateEditDialogDieuChuyenLichSu;